import { render, staticRenderFns } from "./TabCol.vue?vue&type=template&id=02108515&scoped=true&"
import script from "./TabCol.vue?vue&type=script&lang=js&"
export * from "./TabCol.vue?vue&type=script&lang=js&"
import style0 from "./TabCol.vue?vue&type=style&index=0&id=02108515&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02108515",
  null
  
)

export default component.exports